import styled from 'styled-components';
import { devices, deviceSizes } from '../../../config/devices';
export var BoxContianer = styled.div.withConfig({
  displayName: "style__BoxContianer",
  componentId: "sc-13n2ojh-0"
})(["&&{min-height:80vh;margin-right:0;margin-left:0;display:flex;", " transition:margin 225ms cubic-bezier(0.4,0,0.6,1) 0ms;background-color:#fafafa;", " @media ", "{padding:4.5rem 0 5rem 0;}@media ", "{padding:3.6rem 0 5rem 0;margin-left:0;}}"], function (_ref) {
  var contentPadding = _ref.contentPadding;
  return "padding: ".concat(contentPadding, "rem ").concat(contentPadding, "rem;");
}, function (_ref2) {
  var hasSidebar = _ref2.hasSidebar,
    isOpen = _ref2.isOpen;
  return hasSidebar ? "\n     margin-left: ".concat(isOpen ? "240px" : "60px", ";\n    //  width: ").concat(isOpen ? "calc(100% - 240px)" : "calc(100% - 60px)", ";\n    width: 100%;\n\n    ") : "\n    width: 100%;\n    margin-left:0;\n    \n    ";
}, devices.sm, devices.xs);
export var LayoutContainer = styled.div.withConfig({
  displayName: "style__LayoutContainer",
  componentId: "sc-13n2ojh-1"
})(["display:flex;flex-direction:column;width:100%;"]);
export var ContentContainer = styled.div.withConfig({
  displayName: "style__ContentContainer",
  componentId: "sc-13n2ojh-2"
})(["display:flex;flex-direction:row;"]);
export var VerficationContainer = styled.div.withConfig({
  displayName: "style__VerficationContainer",
  componentId: "sc-13n2ojh-3"
})(["margin-top:64px;@media ", "{margin-top:0;}@media only screen and (min-width:", ") and (max-width:", "){margin-top:-8px;}"], devices.sm, deviceSizes.sm, deviceSizes.md);